
export const SLIPPAGE_TOLERANCE_PERCENTAGE = 6.5;
